export default "__VITE_ASSET__BffjvP6M__"